import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCreateProject = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 36,
	height: 37,
	viewBox: "0 0 36 37",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		id: "Create Project/Feedback",
		children: /* @__PURE__ */ _jsx("path", {
			id: "Vector",
			d: "M18 0.0625C8.082 0.0625 0 8.1445 0 18.0625C0 27.9805 8.082 36.0625 18 36.0625C27.918 36.0625 36 27.9805 36 18.0625C36 8.1445 27.918 0.0625 18 0.0625ZM25.2 19.4125H19.35V25.2625C19.35 26.0005 18.738 26.6125 18 26.6125C17.262 26.6125 16.65 26.0005 16.65 25.2625V19.4125H10.8C10.062 19.4125 9.45 18.8005 9.45 18.0625C9.45 17.3245 10.062 16.7125 10.8 16.7125H16.65V10.8625C16.65 10.1245 17.262 9.5125 18 9.5125C18.738 9.5125 19.35 10.1245 19.35 10.8625V16.7125H25.2C25.938 16.7125 26.55 17.3245 26.55 18.0625C26.55 18.8005 25.938 19.4125 25.2 19.4125Z",
			fill: "currentColor"
		})
	})
});
export default SvgCreateProject;
